const clasParagraph = "w-full text-[#494949] text-[13px] ";

export const returnText = (text: string) => {
    return (
        <p className={clasParagraph}>
            {text}
        </p>
    )
}

export const returnTextWithSpam = (number: string, spam: string, text: string) => {
    return (
        <div className="w-full text-[#494949] text-[13px] grid grid-cols-[auto_1fr] gap-1">
            <span className="whitespace-nowrap">{number}</span>
            <div>
                <span className='font-semibold mr-1'>{spam}</span>
                <span>{text}</span>
            </div>
        </div>
    )
}

export const returnTextWithNumber = (number: string, text: string) => {
    return (
        <div className="w-full text-[#494949] text-[13px] grid grid-cols-[auto_1fr] gap-1">
            <span className="whitespace-nowrap">{number}</span>
            <div>
                <span>{text}</span>
            </div>
        </div>
    )
}